import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme.service';
import { ObtenerDatosService } from '../../../servicios/datos/obtener-datos/obtener-datos.service';
import { GlobalesService } from '../../../servicios/globales.service';
import { Router } from '@angular/router';
import { RutasService } from '../../../servicios/rutas/rutas.service';

@Component({
  selector: 'app-votos-extra',
  templateUrl: './votos-extra.component.html',
  styleUrls: ['./votos-extra.component.scss']
})

export class VotosExtraComponent {

  @Input() public distrito_param: any = '';
  @Input() public omitirAnticipados: any = false;
  @Input() public omitirPreventivos: any = false;
  @Input() public omitirAnticipadosDem = true;
  @Input() public omitirPreventivosDem = true;

  selectedContienda: any = '';
  ruta_anticipados: any = '';
  ruta_preventivos: any = '';

  constructor(
    public _obtenerDatosService:ObtenerDatosService,
    public globalService: GlobalesService,
    public themeService: ThemeService,
    public router: Router,
    public rutasService: RutasService,
  ) {
    
  }

  ngOnInit(): void {
    this.selectedContienda = this.globalService.getContienda();
    if(!this.distrito_param){
      this.ruta_anticipados = this.selectedContienda+'/votos-anticipados';
      this.ruta_preventivos = this.selectedContienda+'/votos-preventivos';
    }else{
      this.ruta_anticipados = this.selectedContienda+'/'+this.distrito_param+'/votos-anticipados';
      this.ruta_preventivos = this.selectedContienda+'/'+this.distrito_param+'/votos-preventivos';
    }
    console.log(this.ruta_anticipados, '  ::  ',this.ruta_preventivos);

    this._obtenerDatosService.configSubject.subscribe(data =>{
      if (data != null) {
        const omitirAnt = data.omitir_votos_anticipados;
        const omitirPrev = data.omitir_votos_preventivos;
        this.omitirAnticipados = (!omitirAnt || (omitirAnt && (omitirAnt == 'false' || omitirAnt == false) )) ? false : true;
        this.omitirPreventivos = (!omitirPrev || (omitirPrev && (omitirPrev == 'false' || omitirPrev == false) )) ? false : true;
      }
    });
  }

}
